export default function replaceByDefault(e) {
  // Check if this is already the Google favicon fallback to prevent infinite loop
  if (e.target.src.includes('google.com/s2/favicons')) {
    // Use local placeholder image as final fallback
    e.target.src = require('../assets/favicon_1.png')
    e.target.classList.add('placeholder-image')
    return
  }
  
  // Check if we're already using the placeholder to prevent infinite loop
  if (e.target.src.includes('favicon_1.png')) {
    e.target.classList.add('placeholder-image')
    return
  }
  
  // Try to extract website from original URL
  try {
    const urlParts = e.target.src.split('?')
    if (urlParts.length > 1) {
      const params = urlParts[1].split('&')
      const websiteParam = params.find(param => param.includes('website'))
      
      if (websiteParam) {
        const website = websiteParam.split('website=')[1]
        if (website && website !== 'n' && website.trim() !== '') {
          // Try Google favicon service as first fallback
          e.target.src = `https://www.google.com/s2/favicons?domain_url=${website}`
          return
        }
      }
    }
    
    // If we can't extract a valid website, use placeholder
    e.target.src = require('../assets/favicon_1.png')
    e.target.classList.add('placeholder-image')
  } catch (error) {
    // If any error occurs, use placeholder
    e.target.src = require('../assets/favicon_1.png')
    e.target.classList.add('placeholder-image')
  }
}
